export const colorPalette = ['#296b8e', 'lightgrey', '#9e272f'] as [string, string, string]